import { AuthenticateForm } from '@website/components/auth/AuthenticationModal';
import { Store } from '@website/Store';
import { useContext } from 'react';
import { Spinner } from 'react-bootstrap';
import SelectBooking from './SelectBooking';

export default function ExistingBookings() {
  const { state } = useContext(Store);

  if (state.isAuthenticating) return <Spinner animation="border" />;

  if (!state.isAuthenticated) {
    return (
      <div className="mt-3">
        <h2 className="h4">Let's get you signed in first...</h2>

        <p>Let's do that now, so we can locate your booking.</p>

        <AuthenticateForm />
      </div>
    );
  }

  return <SelectBooking userID={state.user.id} />;
}
